"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultTreasuryAPI = void 0;
const big_js_1 = __importDefault(require("big.js"));
const utils_1 = require("../utils");
const transaction_1 = require("./transaction");
class DefaultTreasuryAPI extends transaction_1.DefaultTransactionAPI {
    constructor(api, account) {
        super(api, account);
    }
    total() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const totalBN = yield this.api.query.wrapped.totalIssuance.at(head);
            return new big_js_1.default(utils_1.satToBTC(totalBN.toString()));
        });
    }
    balance(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield this.api.query.wrapped.account(id);
            return new big_js_1.default(utils_1.satToBTC(account.free.toString()));
        });
    }
    subscribeToBalance(account, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const accountId = this.api.createType("AccountId", account);
                const unsubscribe = yield this.api.query.wrapped.account(accountId, (balance) => {
                    callback(account, new big_js_1.default(utils_1.satToBTC(balance.free.toString())));
                });
                return unsubscribe;
            }
            catch (error) {
                console.log(`Error during treasury balance subscription callback: ${error}`);
            }
            // as a fallback, return an empty void function
            return () => {
                return;
            };
        });
    }
    transfer(destination, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const amountSmallDenomination = this.api.createType("Balance", utils_1.btcToSat(amount.toString()));
            const transferTransaction = this.api.tx.wrapped.transfer(destination, amountSmallDenomination);
            yield this.sendLogged(transferTransaction, this.api.events.wrapped.Transfer);
        });
    }
}
exports.DefaultTreasuryAPI = DefaultTreasuryAPI;
//# sourceMappingURL=treasury.js.map